module.exports = __webpack_public_path__ + "static/media/bellza1.412f427d.png";